import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenderAmountPipe } from './tender-amount.pipe';

@NgModule({
  declarations: [TenderAmountPipe],
  imports: [CommonModule],
  exports: [TenderAmountPipe] // Ensure the pipe is exported
})
export class PipesModule { }